import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  DragDropContext,
  Draggable,
  DraggingStyle,
  Droppable,
  DropResult,
  NotDraggingStyle
} from "@hello-pangea/dnd";

import layer from "../../assets/images/icons/whiteboard-menu-left-3.svg";
import btnHideLayer from "../../assets/images/icons/whiteboard-menu-left-4.svg";
import btnShowLayer from "../../assets/images/icons/whiteboard-menu-left-7.svg";
import drag from "../../assets/images/tool/drag-icon.svg";

const LayerTool = (props: any) => {
  const {
    data,
    setData,
    boardElementStore,
    setVisibilityByIds,
    onUpdate,
    showLayerModal,
    toggleLayerModal,
    setSchedule,
    setLayerUpdateLoad,
    selectedDivs
  } = props;
  const [onReady, setOnReady] = useState(false);
  const [sortedData, setSortedData] = useState([]);

  useEffect(() => {
    setOnReady(true);
  }, []);

  useEffect(() => {
    setSortedData(data.slice().sort((a: any, b: any) => b.idx - a.idx));
  }, [data]);

  const reorder = (
    list: any[],
    startIndex: number,
    endIndex: number
  ): any[] => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    result.reverse().map((item: any, idx: any) => {
      item.idx = idx;
      item.zIndex = idx * 2;
    });
    result.sort((a: any, b: any) => b.idx - a.idx);
    
    return result;
  };

  const onDragEnd = (result: DropResult): void => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items: any[] = reorder(
      sortedData,
      result.source.index,
      result.destination.index
    );
    setLayerUpdateLoad(true);
    setData(items);
    setSchedule(items);
    // setData([]);
    // setSchedule([]);
    // setTimeout(() => {
    //   setData(items);
    //   setSchedule(items);
    // }, 100);
  };

  const toggleDisplay = (item: any) => {
    if (boardElementStore[item.id]) {
      setVisibilityByIds([item.id], false);
    } else {
      setVisibilityByIds([item.id], 'toggle');
    }
  };

  useEffect(() => {
    console.log('selectedDivs', selectedDivs);
    
  }, [selectedDivs]);

  return (
    <React.Fragment>
      <button className="feature-anchor top-tool-btn drawhide-btn" onClick={() => toggleLayerModal()} data-tooltip-content="圖層列表">
        <img src={layer} style={{ width: "32px" }} alt="" />
      </button>
      <Modal id="layerModal" className={`h-100 w-100 items-center justify-center ${onReady? "layerReady" : ""}`} isOpen={showLayerModal} toggle={toggleLayerModal} modalClassName="zoomIn" zIndex={1000120}>
        <ModalHeader toggle={toggleLayerModal}></ModalHeader>
        <div className="w-100 mt-1 text-center"><label htmlFor="qr-code" className="crs-subtitle"> 圖層列表 </label></div>
        <div id="layerlist" className="list-content">
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided, snapshot): JSX.Element => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="layerList"
                >
                  {sortedData.map((item: any, index: number) => (
                    <Draggable key={item.id} draggableId={item.id} index={index}>
                      {(provided, snapshot): JSX.Element => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          className={`layerItem ${snapshot.isDragging? "isDragging" : ""} ${ item.selected || selectedDivs.some((div: any) => div.id === item.id)? "layerThis" : "" }`}
                        >
                          <div className="layerBack"></div>
                          <div className="pageDrag">
                            <img src={drag} alt=""  {...provided.dragHandleProps} />
                          </div>
                          {/* <div className="layerTitle" data-num={`${index + 1}`}>
                            {item.listTitle}
                          </div> */}
                          <div className="layerTitle">
                            {item.listTitle}
                          </div>
                          <div className="layerLock">

                          </div>
                          <div className="layerIcon" onClick={() => toggleDisplay(item)}>
                            {boardElementStore[item.id]? (
                              <img src={btnHideLayer} style={{ width: "20px" }} alt="" />
                            ) : (
                              <img src={btnShowLayer} style={{ width: "20px" }} alt="" />
                            )}
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default LayerTool;